import { render, staticRenderFns } from "./attr-color.vue?vue&type=template&id=405e66a1&scoped=true"
import script from "./attr-color.vue?vue&type=script&lang=js"
export * from "./attr-color.vue?vue&type=script&lang=js"
import style0 from "./attr-color.vue?vue&type=style&index=0&id=405e66a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e66a1",
  null
  
)

export default component.exports